
import * as React from 'react';
import axios from 'axios';
import { getCookies } from "cookies-next";
import ImageUploading from 'react-images-uploading';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import { config } from '../../data/config';
import Swal from 'sweetalert2';
import ImageUploader from '../tools/uploaderImage';
import { useTranslation } from 'react-i18next';
import { Input } from 'rsuite';
import ImageUploaders from '../tools/uploaderimages';

const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";

export default function TissGallery({ data, reload }: any) {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [images, setImages] = React.useState([]);
    const [listimage, setlistimage] = React.useState([]);

    const [newitem, setItemEdit] = React.useState(data.toimage == null ? false : true);
    const [show, setShow] = React.useState(true);
    const [text, setText] = React.useState(data!.data != undefined ? data!.data.html : '');

    const startedit = () => {
        setItemEdit(true);
        setShow(false);
    }
    const backtopreviw = () => {
        setItemEdit(true);
        setShow(true);
    }
    const inputHandler = (event: any, editor: any) => {
        setShow(editor.getData())
        setText(editor.getData())
    };
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };
    const save = async () => {

        try {
            var path = `${config.url}/v1/dashboard/component/texteditor/${data._id}`;

            let res = await axios({
                method: 'put',
                data: {
                    html: text
                },
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire('update');
        } catch (error) {

        }
    }
    const loaditem = async () => {
        await axios({
            method: "get",
            url: config.url + "/v1/dashboard/filemanager?id=" + data.id + "&component=ImageSlider",
            headers: {
                Authorization: 'Bearer ' + cookie['token'],
                "Content-Type": "multipart/form-data"
            },
        })
            .then(function (response) {

                setlistimage(response.data.data)

            })
            .catch(function (response) {
                //handle error
                console.log(response);
            });
    }
    React.useEffect(() => {
        loaditem();
    }, []);
    return (
        <div className='w-[100%] p-4' dir='ltr'>


            <div onClick={(e) => { startedit() }}>

                <div>
                    <Carousel responsive={responsive}>
                        {listimage.map((item: any) => {
                            return (
                                <div className='p-4'>
                                    <img src={config.fronturl + '/' + item.url}  className='w-full h-[400px] object-fill' ></img>

                                </div>
                            )
                        })}

                    </Carousel>

                </div>
            </div>
            <div>

                {

                    <div className='text-center flex flex-col gap-3 align-center'>

                        <ImageUploaders  reload={loaditem} count={60} id={data.id} component={'ImageSlider'}></ImageUploaders>


                        <Input
                            defaultValue={data!.data != undefined ? data!.data.html : ''}
                            type="text"
                            className={`${inputstyle}   text-right `}
                            placeholder="Alt"
                            onChange={(e) => setText(e)}
                        />

                        <div className='mt-3 flex gap-4' dir='rtl'>
                            <button onClick={(e) => {
                                save();
                            }} className=" hover:bg-blue-700  hover:text-white text-black font-bold  px-4 border border-blue-700 rounded">
                                {t('Apply')}
                            </button>

                        </div>
                        <div>

                        </div>
                    </div>
                }
            </div>


        </div>
    )
}